import { Stack, Typography } from '@mui/material';
import { FontWeights } from 'shared';
import { KycForm } from 'widgets/kyc-form';

export const KycPage = () => {
  return (
    <Stack spacing="34px">
      <Typography variant="h1" fontWeight={FontWeights.Light}>
        Stars exchange
      </Typography>
      <KycForm />
    </Stack>
  );
};
